import { UserRole } from "../store/store.model";
import { relationshipModel } from "../models";
export let Intent = /*#__PURE__*/function (Intent) {
  Intent["AddPaymentMethod"] = "addPaymentMethod";
  Intent["OpenAccountantAccessRequest"] = "openAccountantAccessRequest";
  Intent["QboMapServices"] = "qboMapServices";
  Intent["QboSetupMapContacts"] = "qboSetupMapContacts";
  Intent["InvoiceApprovePayment"] = "invoiceApprovePayment";
  Intent["InvoiceResolvePayment"] = "invoiceResolvePayment";
  Intent["InvoiceStopPayment"] = "invoiceStopPayment";
  Intent["InvoicePayNow"] = "invoicePayNow";
  Intent["InvoiceResumePayment"] = "invoiceResumePayment";
  Intent["ApproveCharge"] = "approveCharge";
  Intent["InviteTeamMember"] = "inviteTeamMember";
  Intent["RemoveAccountAccess"] = "removeAccountAccess";
  Intent["DeclineAutoApproval"] = "declineAutoApproval";
  Intent["ApproveAllAmendments"] = "approveAllAmendments";
  Intent["InvoiceRejectPaymentExtension"] = "invoiceRejectPaymentExtension";
  Intent["InvoiceApprovePaymentExtension"] = "invoiceApprovePaymentExtension";
  Intent["InvoiceRetryCharge"] = "invoiceRetryCharge";
  Intent["ApproveAllBar"] = "approveAllBar";
  Intent["SelectPackage"] = "selectPackage";
  Intent["DownloadAgreementPdf"] = "downloadAgreementPdf";
  Intent["DuplicateAgreement"] = "duplicateAgreement";
  Intent["CopyRelationshipDirectLink"] = "copyRelationshipDirectLink";
  Intent["TerminateAgreement"] = "terminateAgreement";
  Intent["SendProposal"] = "sendProposal";
  Intent["SendProposalReminder"] = "sendProposalReminder";
  Intent["EditProposal"] = "editProposal";
  Intent["DuplicateProposal"] = "duplicateProposal";
  Intent["CancelProposal"] = "cancelProposal";
  Intent["InvoiceMarkPaidExternally"] = "invoiceMarkPaidExternally";
  Intent["InvoiceResend"] = "invoiceResend";
  Intent["InvoiceDownload"] = "invoiceDownload";
  Intent["InvoiceVoid"] = "invoiceVoid";
  Intent["InvoiceCopyLink"] = "invoiceCopyLink";
  Intent["UpdateBusinessDetails"] = "updateBusinessDetails";
  Intent["ChangeRole"] = "changeRole";
  Intent["ResendMemberInvitation"] = "resendMemberInvitation";
  Intent["RemoveFromTeam"] = "removeFromTeam";
  Intent["UpdateProfile"] = "updateProfile";
  Intent["OpenHelpMenu"] = "openHelpMenu";
  Intent["ApproveProposal"] = "approveProposal";
  Intent["ProposalSwitchCompany"] = "proposalSwitchCompany";
  Intent["RejectDelivery"] = "rejectDelivery";
  Intent["ApproveDelivery"] = "approveDelivery";
  Intent["QboMapAccounts"] = "qboMapAccounts";
  Intent["QboDisconnect"] = "qboDisconnect";
  Intent["ClientViewProposal"] = "clientViewProposal";
  Intent["VendorViewProposal"] = "vendorViewProposal";
  Intent["CreateProposalTemplate"] = "createProposalTemplate";
  Intent["EditProposalTemplate"] = "editProposalTemplate";
  Intent["ViewProposalTemplate"] = "viewProposalTemplate";
  Intent["UseProposalTemplate"] = "useProposalTemplate";
  Intent["RenameProposalTemplate"] = "renameProposalTemplate";
  Intent["RemoveProposalTemplate"] = "removeProposalTemplate";
  Intent["DiscardDraft"] = "discardDraft";
  Intent["AddCharge"] = "addCharge";
  Intent["AddCredit"] = "addCredit";
  Intent["RemoveCredit"] = "removeCredit";
  Intent["Bill"] = "bill";
  Intent["RemoveCharge"] = "removeCharge";
  Intent["EnterAccountantAccess"] = "enterAccountantAccess";
  Intent["ClientCreateVendorAccount"] = "clientCreateVendorAccount";
  Intent["RequestRefund"] = "requestRefund";
  Intent["SelectOptionalService"] = "selectOptionalService";
  return Intent;
}({});
const forbiddenTooltipText = "You don't have permission to perform this action. Contact the account owner to grant you access.";
const openToAll = new Set([UserRole.Accountant, UserRole.Admin, UserRole.Member, UserRole.Owner, UserRole.AnchorAdmin, UserRole.Reviewer]);
const openToOwnerAdminAndAnchorAdmin = new Set([UserRole.Admin, UserRole.Owner, UserRole.AnchorAdmin]);
const openToAllExceptMembersAndReviewers = new Set([UserRole.Owner, UserRole.Admin, UserRole.Accountant, UserRole.AnchorAdmin]);
const openToAllExceptAccountantAndReviewer = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member, UserRole.AnchorAdmin]);
const openToAllExceptAnchorAdminAndReviewer = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member, UserRole.Accountant]);
const openToOwnerAndAdmin = new Set([UserRole.Admin, UserRole.Owner]);
const openToOwnerAdminAndMember = new Set([UserRole.Owner, UserRole.Admin, UserRole.Member]);
const accessControlAllowList = {
  [Intent.AddPaymentMethod]: openToAll,
  [Intent.OpenAccountantAccessRequest]: openToOwnerAdminAndAnchorAdmin,
  [Intent.QboMapServices]: openToOwnerAdminAndAnchorAdmin,
  [Intent.QboSetupMapContacts]: openToOwnerAdminAndAnchorAdmin,
  [Intent.QboMapAccounts]: openToAllExceptAccountantAndReviewer,
  [Intent.QboDisconnect]: openToAllExceptAccountantAndReviewer,
  [Intent.InvoiceApprovePayment]: openToOwnerAndAdmin,
  [Intent.InvoiceResolvePayment]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceStopPayment]: openToOwnerAndAdmin,
  [Intent.InvoicePayNow]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceResumePayment]: openToOwnerAdminAndAnchorAdmin,
  [Intent.ApproveCharge]: openToOwnerAndAdmin,
  [Intent.InviteTeamMember]: openToOwnerAdminAndAnchorAdmin,
  [Intent.RemoveAccountAccess]: openToOwnerAdminAndAnchorAdmin,
  [Intent.DeclineAutoApproval]: openToOwnerAdminAndAnchorAdmin,
  [Intent.ApproveAllAmendments]: openToOwnerAndAdmin,
  [Intent.InvoiceRejectPaymentExtension]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceApprovePaymentExtension]: openToOwnerAdminAndAnchorAdmin,
  [Intent.InvoiceRetryCharge]: openToOwnerAndAdmin,
  [Intent.ApproveAllBar]: openToOwnerAndAdmin,
  [Intent.SelectPackage]: openToOwnerAdminAndAnchorAdmin,
  [Intent.RemoveFromTeam]: openToOwnerAdminAndAnchorAdmin,
  [Intent.DuplicateAgreement]: openToAllExceptAccountantAndReviewer,
  [Intent.TerminateAgreement]: openToAllExceptAccountantAndReviewer,
  [Intent.SendProposal]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.SendProposalReminder]: openToAllExceptAccountantAndReviewer,
  [Intent.EditProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.DuplicateProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.CancelProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.InvoiceMarkPaidExternally]: openToOwnerAdminAndMember,
  [Intent.InvoiceResend]: openToAllExceptAccountantAndReviewer,
  [Intent.InvoiceDownload]: openToAll,
  [Intent.InvoiceVoid]: openToOwnerAdminAndMember,
  [Intent.InvoiceCopyLink]: openToAll,
  [Intent.UpdateBusinessDetails]: openToAllExceptAccountantAndReviewer,
  [Intent.ChangeRole]: openToAllExceptAccountantAndReviewer,
  [Intent.ResendMemberInvitation]: openToAllExceptAccountantAndReviewer,
  [Intent.UpdateProfile]: openToAll,
  [Intent.OpenHelpMenu]: openToAllExceptAccountantAndReviewer,
  [Intent.ApproveProposal]: openToOwnerAdminAndMember,
  [Intent.ProposalSwitchCompany]: openToAllExceptAccountantAndReviewer,
  [Intent.RejectDelivery]: openToOwnerAdminAndMember,
  [Intent.ApproveDelivery]: openToOwnerAdminAndMember,
  [Intent.DownloadAgreementPdf]: openToAll,
  [Intent.CopyRelationshipDirectLink]: openToAll,
  [Intent.ClientViewProposal]: openToAllExceptAccountantAndReviewer,
  [Intent.VendorViewProposal]: openToAll,
  [Intent.CreateProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.EditProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.ViewProposalTemplate]: openToAll,
  [Intent.UseProposalTemplate]: openToAll,
  [Intent.RenameProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.RemoveProposalTemplate]: openToAllExceptMembersAndReviewers,
  [Intent.DiscardDraft]: openToAll,
  [Intent.AddCharge]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.AddCredit]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.RemoveCredit]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.Bill]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.RemoveCharge]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.EnterAccountantAccess]: openToAllExceptAnchorAdminAndReviewer,
  [Intent.ClientCreateVendorAccount]: openToOwnerAdminAndMember,
  [Intent.RequestRefund]: openToOwnerAdminAndAnchorAdmin,
  [Intent.SelectOptionalService]: openToOwnerAdminAndAnchorAdmin
};
function getForbiddenTooltipText(intent, primaryName) {
  switch (intent) {
    case Intent.SelectOptionalService:
      return "Only ".concat(primaryName || 'primary recipient', " can select optional services");
    default:
      return forbiddenTooltipText;
  }
}
export function getIntentBehavior(userRole) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    MULTIPLE_RECEPIENTS: false
  };
  const isSignatory = (opts === null || opts === void 0 ? void 0 : opts.relationship) && opts.userId && relationshipModel.isSignatory(opts.relationship, opts.userId);
  const primaryName = opts !== null && opts !== void 0 && opts.relationship ? relationshipModel.buyerFullName(opts.relationship) : undefined;
  const warn = intent => console.warn('[access-control] unrecognized intent:', intent);
  const isAllowed = intent => {
    if (intent === Intent.ApproveProposal && isSignatory) {
      return true;
    }
    const allowList = accessControlAllowList[intent];
    if (!allowList) {
      warn(intent);
      return true;
    }
    return allowList.has(userRole);
  };
  return {
    getDisabled(intent) {
      if (!userRole) return false;
      return !isAllowed(intent);
    },
    getTooltip(intent) {
      if (!userRole) return null;
      return isAllowed(intent) ? null : opts.MULTIPLE_RECEPIENTS ? getForbiddenTooltipText(intent, primaryName) : forbiddenTooltipText;
    }
  };
}